export default __webpack_public_path__ + "assets/webgl/picking-15.4251268d.glb";